import { Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '@app/store/app.reducer';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import * as fromDocuments from '@app/my-zone/pages/claims/store/actions/documents.actions';
import { filter, map } from 'rxjs/operators';
import { DocumentsService } from '@app/my-zone/pages/claims/store/effects/documents.service';
import { Bewijsstuk } from '@app/core/interfaces/bewijsstukken';

@Component({
    selector: 'ins-upload-form-container',
    template: `
        <ins-upload-form
            [evidenceIndex]="evidenceIndex"
            (uploadDocument)="onUploadDocument($event)"
            (deleteDocument)="onDeleteDocument($event)"
            [evidence]="evidenceDocument$ | async"
            [evidenceDocuments]="evidenceDocuments"
            [errors]="errors$ | async">
        </ins-upload-form>
    `
})
export class UploadFormContainer {
    @Input() evidenceDocuments: Bewijsstuk;
    @Input() evidenceIndex: number;

    public lastUpload$: Observable<any> = this.store.pipe(select(fromMyClaims.getLastUpload));
    public evidenceDocument$: Observable<Bewijsstuk[]>;
    public errors$: Observable<any> = this.store.pipe(
        select(fromMyClaims.getDocumentsState),
        filter((state) => !!state.messages.messages),
        map((messages) => {
            return messages.messages;
        })
    );
    public isLoading$: Observable<boolean> = this.store.pipe(select(fromMyClaims.isDocumentsLoading));

    constructor(
        private store: Store<fromRoot.State>,
        private documentsService: DocumentsService
    ) {}

    public onUploadDocument(payload): void {
        this.store.dispatch(new fromDocuments.Upload(payload));

        // trying to access the new document right after dispatching upload action leads to a timing issue,
        // that is why a timeout is needed
        setTimeout(() => {
            this.evidenceDocument$ =
                this.documentsService.getDocuments$(this.evidenceDocuments.dossier_volgnummer)
                    .pipe(map((res) => {
                        let evidence = res.data.bewijsstuk;
                        if (this.evidenceDocuments.document_id === 'EXDO') {
                            evidence = [
                                ...evidence,
                                this.evidenceDocuments,
                            ];
                        }
                        return evidence;
                    }));
        }, 0);
    }

    public onDeleteDocument(payload): void {
        this.store.dispatch(new fromDocuments.RemoveUpload(payload));
    }
}
